module.exports = __webpack_public_path__ + "img/apple_pick_hand_hold_run_original.3ee3ec6e.jpg";